import React, { Component } from 'react';
import './styles.scss';
import GELOGO from '../../Assets/Images/Stacked.ico'
import {
  userSidemenuItems,
  profileItem,
  trainerSidemenuItems,
  logoutItem,
} from './SidemenuConstants';
import {
  getSubscription,
  getSubscriptionInfo,
} from 'src/Actions/Subscription/subscriptionAction';
import {
  getProfileDetails,
} from 'src/Actions/Profile/profileActions';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setMenuItems } from 'src/Utils';
import { AnalyticsService } from 'src/Analytics/AnalyticsService';
import { signOut } from 'src/authConfig';
import { GE_DOMAIN } from 'src/Config/constants';

let loginType = localStorage.getItem('loginType');
class Sidemenu extends Component {
  constructor(props) {
    super(props);
    let { b, c, adhoc, activeConfigList } = this.props.subscription;
    this.state = {
      sideMenuList:
        loginType === GE_DOMAIN
          ? trainerSidemenuItems
          : setMenuItems(userSidemenuItems, b, c, adhoc, activeConfigList),
      activeItem: null,
    };
  }

  componentDidMount() {
    this.props.getProfileDetails();
    let { sideMenuList } = this.state;
    let { b, c, adhoc, activeConfigList } = this.props.subscription;
    let activeItem = localStorage.getItem('activeItem');
    console.log(activeItem)
    this.setState(
      {
        sideMenuList:
          loginType === GE_DOMAIN
            ? trainerSidemenuItems
            : setMenuItems(userSidemenuItems, b, c, adhoc, activeConfigList),
        activeItem,
      },
      () => {
        if (loginType !== GE_DOMAIN) {
          this.props.getSubscription();
        }
        sideMenuList.forEach((menu) => {
          menu.status = menu.key === activeItem ? true : false;
        });
        this.setState({
          sideMenuList,
        });
      }
    );
  }

  componentDidUpdate(prevProps) {
    if (prevProps.subscription !== this.props.subscription) {
      let { b, c, adhoc, activeConfigList } = this.props.subscription;
      this.setState({
        sideMenuList:
          loginType === GE_DOMAIN
            ? trainerSidemenuItems
            : setMenuItems(userSidemenuItems, b, c, adhoc, activeConfigList),
      });
    }
    
    if(this.state.activeItem !== localStorage.getItem('activeItem'))
    {
      this.setState({activeItem:localStorage.getItem('activeItem')});
    }
  }

  setActiveItem = (item) => {
    window.digitalData.link = {
      linkName: item.key,
      linkType: 'SideMenu Navigation',
    };
    AnalyticsService.trackEvent('link_click');

    localStorage.setItem('activeItem', item.key);
    if (loginType !== GE_DOMAIN) {
      this.props.getSubscriptionInfo();
    }
    this.setState({
      activeItem: item.key,
    });
    this.props.history.push(item.component);
  };

  refresh = () => {
    window.location.href = `${window.location.origin}`;
  };

  logoutSession = async() => {
    localStorage.removeItem('authLang')
    localStorage.setItem('isAutomaticLogout', false);
    signOut();
  };
  renderLogout = (arr) =>{
    let activeItem = localStorage.getItem('activeItem');
    return arr.map((item, index) => (
      <div
        key={item.key}
        className={
          activeItem === item.key
            ? 'menu-item select-true'
            : 'menu-item select-false'
        }
        id={`${item.key}-container`}
        onClick={() => this.logoutSession()}
      >
        <img src={item.icon} id={item.key} style={{ position: 'relative' }} />
        <div className="title">{item.text}</div>
        
      </div>
    ));
  }

  getProfileIconDetails (profileDetails) {
    let firstLastName = '';
    if(profileDetails)
    {
      if(profileDetails.firstName)
      {
        firstLastName = profileDetails.firstName.charAt(0);
      }
      if(profileDetails.lastName)
      {
        firstLastName = firstLastName + profileDetails.lastName.charAt(0);
      }
      else
      {
        firstLastName = firstLastName + '';
      }
    } 
    return firstLastName;
  }

  renderIcons = (arr, activeItem) => {
    if (!activeItem && loginType === GE_DOMAIN) {
      activeItem = trainerSidemenuItems.find(obj => obj.component === '/customer').key;
    }
    let { notificationCount } = this.props.subscription;
    let {  profileDetails} = this.props.profile;
    return arr.map((item, index) => (
      <div
        key={item.key}
        className={
          activeItem === item.key
            ? 'menu-item select-true'
            : 'menu-item select-false'
        }
        id={`${item.key}-container`}
        onClick={() => this.setActiveItem(item)}
      >
        {item.key !== 'Account'?
        <img src={item.icon} id={item.key} style={{ position: 'relative' }} />
        : ( 
        <div className="account-logo">
        <p className="account-initial">
        {this.getProfileIconDetails(profileDetails)}
      </p>
      </div>)}
        <div className="title">{item.text}</div>
        {item.key === 'Account' && notificationCount > 0 ? (
          <div className="badge-container">
            <span className="badge">{notificationCount}</span>
          </div>
        ) : null}
      </div>
    ));
  };

  render() {
    let darkTheme = localStorage.getItem('darkTheme');
    let {activeItem} = this.state;
    return (
      <>
      {!this.props.generic.initialLoad && <div className={`sidemenu-container-${darkTheme}`}>
         <div className="desktop-wrapper">
            <img src={GELOGO} onClick={this.refresh} />
          <div className="icons">
            {this.renderIcons(this.state.sideMenuList, activeItem)}
            <div className="profile">{this.renderIcons(profileItem, activeItem)}</div>
            <div className = "logout">{this.renderLogout(logoutItem)}</div>
          </div>
        </div>
      </div>}
      </>
    );
  }
}

const mapStateToProps = ({ profile,subscription,generic }) => ({
  profile,
  subscription,
  generic,
});

const mapDispatchToProps = (dispatch) => ({
  getProfileDetails: () => dispatch(getProfileDetails()),
  getSubscriptionInfo: () => dispatch(getSubscriptionInfo()),
  getSubscription: () => dispatch(getSubscription()),
});

export default (withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Sidemenu)
));
